
import React, { useEffect, useState } from "react";   // 👈 ต้องมี {} ตรงนี้
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/CardArticleForm.css";

import { useNavigate } from "react-router-dom";

import { BsStarFill, BsStarHalf, BsStar, BsEye, BsBookmark, BsTerminal, BsCpu, BsAirplane, BsRobot, BsChatSquareHeart, BsFiletypePdf, BsClock } from "react-icons/bs";

import openai_icon from "../../assets/openai_icon.png";
import gemini_icon from "../../assets/gemini_icon.png";
import n8n_icon from "../../assets/n8n_icon.png";
import midjourney from "../../assets/midjourney_icon.png"
import perplexity from "../../assets/perplexity_icon.png";
/* import Logo_Encraft_01 from "../../assets/Logo_Encraft_01.png";
import Logo_Encraft_02 from "../../assets/Logo_Encraft_02.png"; */

// 1) brandKey -> icon
const BRAND_ICON_MAP = {
  openai: openai_icon,
  gemini: gemini_icon,
  n8n: n8n_icon,
  midjourney: midjourney,
  perplexity: perplexity,
 /*  googlesheets: Logo_Encraft_01,
  org: Logo_Encraft_02, */
};

// 2) slug -> brandKey
const SLUG_TO_BRAND_KEY = {
  chatgpt: "openai",
  openai: "openai",
  gemini: "gemini",
  n8n: "n8n",
  midjourney: "midjourney",
  perplexity: "perplexity",
  /* googlesheets: "Logo_Encraft_01",
  org: "Logo_Encraft_02", */
};

// 3) brandKey -> คำค้นที่จะส่งไปหน้า search
//   จะใช้คำเดียวกับ brandKey ก็ได้ หรือจะกำหนดเองแบบนี้ก็ได้
const BRAND_SEARCH_TERM = {
  openai: "chatgpt",   // ถ้าอยากให้ค้นด้วยคำว่า chatgpt
  gemini: "gemini",
  n8n: "n8n",
  midjourney: "midjourney",
  perplexity: "perplexity",
 /*  googlesheets: "Logo_Encraft_01",
  org: "Logo_Encraft_02", */
};


const getSearchTermForBrand = (brandKey) =>
  BRAND_SEARCH_TERM[brandKey] || brandKey;

export default function ArticleCard ({ article }) {
    const navigate = useNavigate();
    // ดึง tagSlugs -> แปลงเป็น brandKey -> unique
    const aiBrandKeys = Array.from(
        new Set(
        (article.tagSlugs || [])
            .map((slug) => slug.toLowerCase())
            .map((slug) => SLUG_TO_BRAND_KEY[slug])  // แปลงเป็น brandKey
            .filter(Boolean)                         // ตัดตัวที่ map ไม่ได้ทิ้ง
        )
    );

  
    const handleClickBrand = (e, brandKey) => {
        e.preventDefault();      // กันไม่ให้ลิงก์การ์ดทำงาน
        e.stopPropagation();     // กัน bubbling ไป Link ด้านนอก
        const term = getSearchTermForBrand(brandKey);
        navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    const handleClickLevel = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = article.level?.toLowerCase() ?? "";
        if (term) navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    const handleClickCategory = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = (article.category || "").toLowerCase();
        if (term) navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    // 👇 ปุ่ม +N → ไปค้นคำว่า "ai tools"
    const handleClickMore = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = "ai tools";   // อยากเปลี่ยนคำค้นก็แก้ตรงนี้ได้เลย
        navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    // ดึง tagSlugs -> brandKey -> unique
    const allBrandKeys = Array.from(
        new Set(
            (article.tagSlugs || [])
            .map((slug) => slug.toLowerCase())
            .map((slug) => SLUG_TO_BRAND_KEY[slug])
            .filter(Boolean)
        )
    );

    // แบรนด์ที่จะแสดงเป็นไอคอนจริง ๆ (สูงสุด 3)
    const firstBrandKeys = allBrandKeys.slice(0, 3);

    // จำนวนแบรนด์ที่เหลือเกินจาก 3
    const extraCount = allBrandKeys.length - firstBrandKeys.length;

  
  return (
    <div className="card article-card shadow-sm h-100">
      {/* รูปภาพ */}
      <div className="image-wrapper">
        <img src={article.image} className="card-img-top" alt={article.title} />
      </div>

      {/* เนื้อหา */}
      <div className="card-body">
        {/* วันที่ + ผู้เขียน */}
        <p className="card-meta">
          {article.date} &nbsp;|&nbsp; {article.author}
        </p>

        {/* ชื่อบทความ (จำกัด 3 บรรทัด) */}
        <h5 className="articlename">{article.title}</h5>

        {/* ส่วนท้าย: ระดับ/วิว ←→ หมวดหมู่ */}
        <div className="level-section">
            <span
                className="level-text"
                role="button"
                style={{ cursor: "pointer" }}
                onClick={handleClickLevel}
            >
                {article.level && (
                  <>
                    {article.level === "general"
                      ? "General"
                      : article.level === "beginner"
                      ? "Beginner"
                      : article.level === "intermediate"
                      ? "Intermediate"
                      : article.level === "advanced"
                      ? "Advanced"
                      : article.level}
                  </>
                )}
            </span>

        {(firstBrandKeys.length > 0 || extraCount > 0) && (
            <div className="level-icons">
                {firstBrandKeys.map((brandKey) => (
                    <img
                    key={brandKey}
                    src={BRAND_ICON_MAP[brandKey]}
                    alt={brandKey}
                    className="level-icon"
                    role="button"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleClickBrand(e, brandKey)}
                    />
                ))}

                {extraCount > 0 && (
                    <span
                    className="level-icon-more"
                   /*  role="button"
                    style={{ cursor: "pointer" }}
                    onClick={handleClickMore} */
                    >
                    +{extraCount}
                    </span>
                )}
            </div>
        )}
        </div>



        <div className="card-footer-section">
          <div className="left">
            
            {article.views != null && (
              <span className="text-secondary">
                <span className="badge-content-type">{article.readTime} min read</span> • {article.views.toLocaleString()} views
              </span>
            )}
          </div>
            <div className="right">
                <span
                    className="badge-content-type"
                   /*  role="button"
                    style={{ cursor: "pointer" }}
                    onClick={handleClickCategory} */
                >
                    {article.subCategoryName}
            </span>
            </div>
        </div>
      </div>
    </div>
  );
};